import React, { useCallback } from "react";

import * as Assets from "../../assets";
import * as Enums from "../../enums";

import s from "./TableHeaderCell.module.scss";

type TAccessor = string | number | boolean;

interface IProps<T extends object> {
	accessor: Extract<keyof T, string>;
	filterable?: boolean;
	sortable?: boolean;
	title: string;
	titleAlign?: "left" | "center" | "right";
	filter?: TAccessor[];
	sort?: Enums.SortDirection;
	onChangeFilter?: (accessor: Extract<keyof T, string>, value: TAccessor) => void;
	onChangeSortDirection?: (accessor: Extract<keyof T, string>, value: Enums.SortDirection) => void;
}

export const TableHeaderCell = <T extends object>({ accessor, filterable, sortable, title, titleAlign, sort, filter, onChangeSortDirection }: IProps<T>): JSX.Element => {

	const openFilterModal = useCallback((event: React.MouseEvent<HTMLImageElement>) => {
		event.stopPropagation();
		event.preventDefault();
	}, []);

	const onClickHandler = useCallback(() => {
		if (onChangeSortDirection && accessor) {
			onChangeSortDirection(accessor, sort === Enums.SortDirection.ASC ? Enums.SortDirection.DESC : Enums.SortDirection.ASC);
		}
	}, [accessor, sort, onChangeSortDirection]);

	return (
		<div className={s.hCell} onClick={onClickHandler}>
			<div className={s.hCell__row}>
				<span className={s.hCell__title} style={{ textAlign: titleAlign }}>{title}</span>
				{sortable && (
					<div className={`${s.hCell__sortContainer} ${sort !== undefined ? s.hCell__visible : ""}`}>
						{(sort === undefined || sort === Enums.SortDirection.ASC) && (
							<img src={Assets.ArrowUp} alt={"sort ask"}/>)}
						{(sort === undefined || sort === Enums.SortDirection.DESC) && (
							<img src={Assets.ArrowDown} alt={"sort desk"}/>)}
					</div>
				)}
				{filterable && (
					<img className={`${s.hCell__filter} ${filter ? s.hCell__visible : ""}`}
						src={filter ? Assets.FilterActive : Assets.Filter} alt={"filter"} onClick={openFilterModal}/>
				)}
			</div>
		</div>
	);
};
